export default __webpack_public_path__ + "static/media/decay_is_an_extant_form_of_life.e0ce651d.png";